const DEFAULT_TIMEOUT = 4000

function createContainer(): HTMLElement {
  const container = document.createElement("div")
  container.id = "temp-notifications-container"
  container.className = "fixed top-5 right-5 z-50 flex flex-col gap-2"
  document.body.appendChild(container)
  return container
}

export function warning(message: string): void {
  const container = document.getElementById("temp-notifications-container") || createContainer()

  const el = document.createElement("div")
  el.setAttribute("role", "alert")
  el.className = "alert alert-soft alert-warning flex items-center gap-4 transition duration-300 ease-in-out"

  const iconSpan = document.createElement("span")
  iconSpan.className = "icon-[material-symbols--warning-rounded] text-2xl"
  el.appendChild(iconSpan)

  const messageSpan = document.createElement("span")
  messageSpan.textContent = message
  el.appendChild(messageSpan)

  const closeBtn = document.createElement("button")
  closeBtn.className = "ms-auto cursor-pointer leading-none"
  closeBtn.setAttribute("aria-label", "Close Button")
  closeBtn.innerHTML = '<span class="icon-[material-symbols--close] text-2xl"></span>'
  closeBtn.addEventListener("click", () => el.remove())
  el.appendChild(closeBtn)

  container.appendChild(el)
  setTimeout(() => el.remove(), DEFAULT_TIMEOUT)
}
